import script from "./InputNumber.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputNumber.vue?vue&type=script&setup=true&lang=ts"

import "./InputNumber.vue?vue&type=style&index=0&id=6ba812f4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ba812f4"]])

export default __exports__